import React, { ReactNode, useMemo } from 'react';
import {
  EnvVars,
  buildConfigContext,
  createBuildConfig,
} from './build-config-context';

type Props = {
  children: ReactNode;
  envVars: EnvVars;
};

export function BuildConfigProvider(props: Readonly<Props>) {
  const { children, envVars = {} } = props;

  const buildConfig = useMemo(() => {
    return createBuildConfig(envVars);
  }, [envVars]);

  const { Provider } = buildConfigContext;
  return <Provider value={buildConfig}>{children}</Provider>;
}
